function filterPhone(value) {
  return value
    .replace(/[^\d\s\-+()]/g, '') // Удаляем запрещенные символы
    .replace(/\s+/g, ' ')         // Заменяем множественные пробелы на один
    .trim();                      // Убираем пробелы в начале и конце
}

export {
  filterPhone
};
